module.exports = __webpack_public_path__ + "project-process.jpg?9a3bdf4ae36eea0e385150147b789309";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/project-process.jpg
// module id = 158
// module chunks = 0